export default "__VITE_ASSET__17aaf366__"